// extracted by mini-css-extract-plugin
module.exports = {"header":"ExportedPanesHeader-styles-module--header--1Bhb3","img":"ExportedPanesHeader-styles-module--img--1XQGD","float":"ExportedPanesHeader-styles-module--float--1wrID"};